import { Outlet } from "react-router-dom";

export default function ExamLayout() {
  return (
    <div className="flex flex-col min-h-screen bg-slate-50">
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
